import { APIClient } from "api/axiosClient";
import { ResponseData } from "api/types/_public";
import { AxiosResponse } from "axios";
import moment from "moment-timezone";
const api = new APIClient();

const chartApi = {
  getPairOhlcv(
    params: any = {}
  ): Promise<AxiosResponse<ResponseData<any>, any>> {
    const pairAddress = params?.address;
    const _params = {
      timeFrame: params?.timeFrame,
      fromDate: params?.fromDate,
      toDate: params?.toDate,
      currency: params?.currency,
      limit: params?.limit
    }
    const url = `/secured/token/pair/${pairAddress}/ohlcv`;
    return api.get(url, _params);
  },
  getTransactions(
    _params: any = {}
  ): Promise<AxiosResponse<ResponseData<any>, any>> {
    const pair_address = _params?.pair_address;
    const params: any = structuredClone(_params);
    delete params.pair_address;
    delete params.hasMore;
    const url = `/secured/token/${pair_address}/getTransaction`;
    return api.get(url, {
      ...params,
      fromDate: !!params?.fromDate ? (moment.tz(params?.fromDate, 'YYYY-MM-DD HH:mm', moment.tz.guess()).utc().valueOf() / 1000).toFixed(0) : '',
      toDate: !!params?.toDate ? ((moment.tz(params?.toDate, 'YYYY-MM-DD HH:mm', moment.tz.guess()).utc().valueOf() + 59000) / 1000).toFixed(0) : '',
    });
  },
  getTransactionsV2(
    _params: any = {}
  ): Promise<AxiosResponse<ResponseData<any>, any>> {
    const pair_address = _params?.pair_address;
    const params: any = structuredClone(_params);
    delete params.pair_address;
    delete params.hasMore;
    delete params.page;
    const url = `/secured/token/${pair_address}/getTransaction/cursor`;
    return api.get(url, {
      ...params,
      fromDate: !!params?.fromDate ? (moment.tz(params?.fromDate, 'YYYY-MM-DD HH:mm', moment.tz.guess()).utc().valueOf() / 1000).toFixed(0) : '',
      toDate: !!params?.toDate ? ((moment.tz(params?.toDate, 'YYYY-MM-DD HH:mm', moment.tz.guess()).utc().valueOf()) / 1000).toFixed(0) : '',
    });
  },
  getTokenInfo(
    params: any = {},
    address: string
  ): Promise<AxiosResponse<ResponseData<any>, any>> {
    const url = `/secured/token/${address}/info`;
    return api.get(url, params);
  },
  getListToken(): Promise<AxiosResponse<ResponseData<any>, any>> {
    const url = `/secured/token/getAll`;
    return api.get(url);
  },
  getFilterData(
    params: any = {},
    address: string
  ): Promise<AxiosResponse<ResponseData<any>, any>> {
    const url = `/secured/token/pair/${address}/latestTradeWithAddressFilter`;
    return api.get(url, params);
  },
};
export default chartApi;
